import React from 'react';
import {Typography} from 'antd';
import {TabItemWrapper, TabWrapper} from './styles';
import {tripModesMultiCity} from '../../screens/Search/constant';
import {useI18nContext} from '../../utils/I18n';
import translations from '../../screens/Search/translations';

type Props = {
  flightMode: string,
  onTripTypeChange: (arg: string) => void
}
const { Text } = Typography;

function FlightModes({ flightMode, onTripTypeChange }: Props) {
  const {
    state: { t },
  } = useI18nContext();
  return (
    <TabWrapper>
      {
        tripModesMultiCity(t(translations)).map((tab) => (tab.value === flightMode ? (
          <TabItemWrapper
            key={tab.id}
            active
            onClick={() => onTripTypeChange(tab.value)}
          >
            <Text>
              {tab.name}
            </Text>
          </TabItemWrapper>
        )
          : (
            <TabItemWrapper
              key={tab.id}
              active={tab.value === flightMode}
              onClick={() => onTripTypeChange(tab.value)}
            >
              <Text
                type="secondary"
              >
                {tab.name}
              </Text>
            </TabItemWrapper>
          )))
      }
    </TabWrapper>
  );
}

export default FlightModes;
